/**
 * 编辑素材组
 */

import { Modal, Button, Form, Input, InputNumber, Cascader, Radio } from 'antd';
import React, { useEffect, useState } from 'react';
import { VerifyEditFormData, ItemDataOPeration } from '../../type';
import materialApi from '../../api';

export enum GROUP_TYPE {
  'PRODUCT' = '0',
  'ADVERT' = '1',
}
interface MatCascadeItemBase {
  /**
   * 唯一id
   */
  id: number;
  /**
   * 业务唯一标识
   */
  businessId: string;
  /**
   * 父id，(下发的唯一id)
   */
  parentId: number;
  /**
   * 名称
   */
  name: string;
  /**
   * 状态, 1: 有效；0: 删除；
   */
  status: number;
  /**
   * 创建人
   */
  creator: string;
  /**
   * 最后编辑人
   */
  lastOperator: string;
  /**
   * 创建时间
   */
  created: string;
  /**
   * 编辑时间
   */
  modified: string;
}

export interface MatCascadeItemL1 extends MatCascadeItemBase {
  /**
   * 层级
   */
  level: 1;
  /**
   * 扩展字段
   */
  ext: {
    /**
     * 组类型
     */
    groupType?: GROUP_TYPE;
    /**
     * 指定白名单用户可见
     */
    whitelist?: string;
    /**
     * 排序
     */
    order?: string;
  };
}

interface ProductGroupIdentifyListItem {
  value: string;
  label: string;
  selectable?: boolean;
  children?: ProductGroupIdentifyListItem[];
}

interface IAddGroupProps {
  visible: boolean;
  onCancel: () => void;
  handleOk: (data: { name: string; totalNum: number; styleId: number; poolStyle: string }) => void;
  itemData: ItemDataOPeration;
  type: string;
  whiteList: string[];
}

const AddGroup = (props: IAddGroupProps) => {
  const { visible, onCancel, handleOk, itemData, type, whiteList } = props;
  const [addFormRef] = Form.useForm<VerifyEditFormData>();
  const [cascadeList, setCascadeList] = useState<MatCascadeItemL1[]>([]);
  const handleSave = async () => {
    try {
      const res = await addFormRef.validateFields();
      const data = {
        styleId: Number.parseInt(styleId, 10),
        name: res.name,
        totalNum: res.totalNum,
        poolStyle: res.poolStyle || '',
      };
      handleOk(data);
    } catch (e) {}
  };
  const [styleId, setStyleId] = useState('');

  let initialValues = {
    name: itemData.name || '',
    totalNum: itemData.num || 1,
  };
  const filterCascadeInfoList = (list: MatCascadeItemL1[], userWhitelist?: string[]): MatCascadeItemL1[] => {
    if (userWhitelist) {
      return list.filter((p) => !p.ext.whitelist || userWhitelist.includes(p.ext.whitelist));
    }
    return list;
  };

  const filterGroupIdentifyList = (
    list: ProductGroupIdentifyListItem[],
    cascade: MatCascadeItemL1[],
    userWhitelist?: string[]
  ): ProductGroupIdentifyListItem[] => {
    if (userWhitelist) {
      return list
        .filter((item) => {
          const c = cascade.find((it) => it.businessId === item.value);
          return !c || !c.ext.whitelist || userWhitelist.includes(c.ext.whitelist);
        })
        .map((item) => {
          if (item.children) {
            return Object.assign({}, item, {
              children: filterGroupIdentifyList(item.children, cascade, userWhitelist),
            });
          }
          return item;
        });
    }
    return list;
  };

  const fetchCascadeList = () => {
    if (cascadeList.length > 0) {
      return;
    }
    materialApi
      .queryMatCascadeList({ parentId: 0 })
      .catch((error) => {
        throw error;
      })
      .then((res) => {
        const list: MatCascadeItemL1[] = [];
        res.data.cascadeInfoList.forEach((p: any) => {
          if (p.level === 1) {
            list.push(p);
          }
        });
        setCascadeList([...list]);
        return res;
      })
      .catch((error) => {
        throw error;
      });
  };

  useEffect(() => {
    fetchCascadeList();
  });

  const styleIdList = () => {
    const staticList: ProductGroupIdentifyListItem[] = filterGroupIdentifyList(
      [
        {
          value: '测试',
          label: '测试',
          children: [
            { value: '10002', label: '有价优惠券' },
            { value: '10003', label: '互联网医院' },
            { value: '10008', label: '中心化频道' },
            // {value: '10004', label: '京东到家商品组'},
            { value: '10007-0', label: '今日必买' },
            { value: '10007', label: '今日必买-联动' },
            { value: '10012', label: '积分兑换商品优惠价' },
          ],
        },
        { value: '6', label: '通用' },
        { value: '4012', label: '物竞天择自营商品组' },
        { value: '10004', label: '京东到家商品组' },
        { value: '5', label: 'PC首页-入口图商品组' },
        { value: '4001', label: '国际大牌-带品牌商品组' },
        { value: '8', label: '秒杀商品组' },
        { value: '7', label: '拼购商品组' },
        { value: '11', label: '总价促销' },
        { value: '13', label: '母婴频道-陪伴计划' },
        { value: '4002', label: '会员频道商品组' },
        { value: '16', label: 'TOPLIFE商品组' },
        { value: '10011', label: '相似商品推荐' },
      ],
      cascadeList || [],
      whiteList
    );
    const lowcodeList: ProductGroupIdentifyListItem[] = filterCascadeInfoList(cascadeList || [], whiteList)
      .filter((c) => c.ext?.groupType !== '1')
      .map((c) => ({ value: c.businessId, label: c.name }));
    // 静态配置项值生成
    const staticValueSet = new Set<string>();
    const checkDuplicated = (set: Set<string>, list: ProductGroupIdentifyListItem[]) => {
      list.forEach((item) => {
        if (item.children) {
          checkDuplicated(set, item.children);
        }
        if (set.has(item.value)) {
          console.error(`Duplicated group create tree value: ${item.label} (${item.value})`);
        }
        set.add(item.value);
      });
    };
    checkDuplicated(staticValueSet, staticList);
    // 低代码类型过滤静态列表中已有的
    return [...staticList, ...lowcodeList.filter((item) => !staticValueSet.has(item.value))];
  };

  const handleChange = (value: any) => {
    const id = value[value.length - 1];
    setStyleId(id);
  };
  const renderStyle = () => {
    if (!styleId) {
      return null;
    }
    // 场次类型
    const options: { label: string; value: string }[] = [];
    if (styleId === '7' || styleId === '6' || styleId === '0' || styleId === '4002' || styleId === '16') {
      if (styleId !== '16') {
        options.push({ label: '多场次', value: '0' });
      }
      if (styleId === '7') {
        options.push({ label: '单场次', value: '1' });
      }
      if (styleId === '6' || styleId === '0' || styleId === '16') {
        options.push({ label: '无限制底池', value: '2' });
      }
    } else {
      // initialValues?.poolStyle = '';
    }
    if (!options.length) {
      return null;
    }
    return (
      <Form.Item name="poolStyle" label="场次类型" initialValue={options[0]?.value}>
        <Radio.Group>
          {options?.map((item) => {
            return (
              <Radio value={item.value} key={item.value}>
                {item.label}
              </Radio>
            );
          })}
        </Radio.Group>
      </Form.Item>
    );
  };
  const list = styleIdList() || [];
  return (
    <Modal title={`${type === 'add' ? '新增' : '编辑'}商品组`} visible={visible} onCancel={onCancel} footer={null}>
      <Form form={addFormRef} initialValues={initialValues}>
        <Form.Item name="name" label="商品组名称" rules={[{ required: true, message: '必填' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="totalNum" label="展示数量" rules={[{ required: true, message: '必填' }]}>
          <InputNumber style={{ width: 100 }} />
        </Form.Item>
        <Form.Item name="styleId" label="商品组类型" rules={[{ required: true, message: '必填' }]}>
          {cascadeList.length > 0 && <Cascader options={list} changeOnSelect onChange={handleChange} />}
        </Form.Item>
        {renderStyle()}

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={() => onCancel()}>取消</Button>
          <Button type="primary" htmlType="submit" style={{ marginLeft: 10 }} onClick={handleSave}>
            确定
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddGroup;
